exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n@media (min-width: 992px) {\n.carrito-articulos-column[data-v-19949b39] {\n        flex: 0 0 70%;\n        max-width: 70%;\n}\n.carrito-total-column[data-v-19949b39] {\n        flex: 0 0 30%;\n        max-width: 30%;\n}\n}\n", ""]);
